import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Col, Form, Input, Popconfirm, Badge } from 'antd';
import { Link, useParams, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '../../popup/popup';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import { logOut, changePassword } from '../../../redux/authentication/actionCreator';
import Heading from '../../heading/heading';
import { Auth } from "../../../services/authService";
import { Modal } from "../../modals/antd-modals";
import { Button } from "../../buttons/buttons";
import { Scope } from "../../../services/scopeService";
import { Constants } from "../../../config/constants";
import { Alert } from "../../../services/alertService";
import alternative from "../../../../src/static/img/demo-profile.png";
import "../../../container/userManagement/profile/css/profile.css";
import { fetchProfileUser, fetchUserSubscription } from "../../../redux/userManagement/users/actionCreator";
import { fetchPermissions } from "../../../redux/utilities/actionCreator";
import { fetchDashboards } from "../../../redux/dashboard/actionCreator";
import { subscribeUserManual, unsubscribeUserManual } from "../../../AppSSEProvider";
import { fetchTeacherUnseenEmails } from "../../../redux/notifications/actionCreator";
import "./style.css"

const AuthInfo = ({ rtl }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.utilities.loading);
    const user = useSelector(state => state.umUsers.user);
    const userSubscriptions = useSelector(state => state.umUsers.userSubscriptions || []);
    const [state, setState] = useState({ visible: false, modalType: 'primary', colorModal: false });
    const [form] = Form.useForm();
    const userInfo = Auth.getUserInfo();
    const params = useParams();
    const { path } = useRouteMatch();

    // Select the notification data from Redux store exactly like MenuItems does
    const teacherUnseenEmails = useSelector(state => state.notifications.teacherUnseenEmails);
    const permissions = useSelector(state => state.utilities.permissions);
    const [myId, setMyId] = useState("");
    const [notifEnabled, setNotifEnabled] = useState(localStorage.getItem('notifications_enabled') === 'true');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Track dynamic viewport scaling updates cleanly
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSyncNotifications = async () => {
        const result = await subscribeUserManual(userInfo?._id);
        if (result) {
            Alert.success({
                title: "Success",
                status: result.message
            });
            dispatch(fetchUserSubscription(userInfo._id));
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        }
    };

    const handleUnsubscribe = async (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        const success = await unsubscribeUserManual(userInfo?._id);
        if (success) {
            Alert.success({ title: "Success", status: "Notifications disabled." });
            dispatch(fetchUserSubscription(userInfo._id));
        }
        setTimeout(() => {
            window.location.reload();
        }, 1500);
    };

    // Pull unread statistics automatically if authorized scope matches
    useEffect(() => {
        if (userInfo?._id && Scope.checkScopes(['domain_emails_teachers_index'])) {
            dispatch(fetchTeacherUnseenEmails());
        }
    }, [dispatch, userInfo?._id]);

    useEffect(() => {
        if (userInfo?._id) {
            if (!permissions || permissions.length === 0) {
                dispatch(fetchPermissions());
            }
        }
    }, [dispatch, permissions, userInfo?._id]);

    useEffect(() => {
        const fetchData = async () => {
            if (params.id) await dispatch(fetchProfileUser(params.id));
        };
        fetchData();
    }, [dispatch, params.id]);

    const [isThisDeviceEnabled, setIsThisDeviceEnabled] = useState(false);

    useEffect(() => {
        if (userInfo?._id) {
            dispatch(fetchUserSubscription(userInfo._id));
        }
    }, [dispatch, userInfo?._id]);

    useEffect(() => {
        const checkSubscriptionOnThisDevice = async () => {
            if (!('serviceWorker' in navigator && 'PushManager' in window)) return;
            try {
                const registration = await navigator.serviceWorker.ready;
                const subscription = await registration.pushManager.getSubscription();
                const subData = userSubscriptions?.data || [];
                if (subscription && subData.length > 0) {
                    const isMatched = subData.some(s => s.endpoint === subscription.endpoint);
                    setIsThisDeviceEnabled(isMatched);
                } else {
                    setIsThisDeviceEnabled(false);
                }
            } catch (error) {
                setIsThisDeviceEnabled(false);
            }
        };
        checkSubscriptionOnThisDevice();
    }, [userSubscriptions]);

    const SignOut = e => {
        e.preventDefault();
        localStorage.removeItem('notifications_enabled');
        setNotifEnabled(false);
        dispatch(logOut());
    };

    const handleSubmit = async (data) => {
        if (userInfo._id) {
            const postData = { currentPassword: data.currentPassword, password: data.password, _id: userInfo._id }
            await dispatch(changePassword(postData, handleCancel()))
        }
    };

    const showModal = async type => {
        form.resetFields();
        setState({
            visible: true,
            modalType: type,
        });
    };

    const handleCancel = () => {
        form.resetFields();
        setState({
            visible: false,
            colorModal: false,
        });
    };

    const validateMessages = {
        required: '${label} is required!',
        lenCheck: '${label} ${min} num is required!',
        types: {
            email: '${label} is not validate email!',
            number: '${label} is not a validate number!',
        },
        number: {
            length: '${label} must be ${min} number',
        },
    };

    const userPhotoUrl = userInfo?._id === myId && user && user?.photo ? user.photo : userInfo?.photo ? `${userInfo?.photo}`
        : userInfo?.gender === "male" ?
            "https://sing-hurdco.s3.ap-southeast-1.amazonaws.com/academic/selected-photos/male-porfile.png"
            : userInfo?.gender === "female" ?
                "https://sing-hurdco.s3.ap-southeast-1.amazonaws.com/academic/selected-photos/female-profile.png"
                : `${Constants.S3_BASE_URL}user/photo/${userInfo?._id}.jpg`;

    const userContent = (
        <UserDropDwon>
            <div className="user-dropdwon">
                <figure className="user-dropdwon__info">
                    <figcaption>
                        <Heading as="h5">{userInfo.full_name}</Heading>
                        <p style={{ fontWeight: "bold" }}>{userInfo?.firstName || ""} {userInfo?.lastName || ""}</p>
                        <hr/>
                        <p>{userInfo?.zoom?.email}</p>
                        <hr/>
                        <p>{userInfo?.username}</p>
                    </figcaption>
                </figure>
                <ul className="user-dropdwon__links">
                    <li>
                        <Link to={`/admin/user-management/profile/${userInfo?._id}`} onClick={() => console.log("Hello")}>
                            <FeatherIcon icon="user" /> Profile
                        </Link>
                    </li>
                    <li>
                        <Link to={`/admin/user-management/password`} >
                            <FeatherIcon icon="lock" /> Change Password
                        </Link>
                    </li>
                </ul>
                <ul className="user-dropdwon__links">
                    {isThisDeviceEnabled && (
                        <li>
                            <Popconfirm
                                title="Disable Alerts on this device?"
                                description="You will stop receiving instant notifications here."
                                onConfirm={handleUnsubscribe}
                                okText="Yes, Disable"
                                cancelText="Cancel"
                                placement="top"
                                okButtonProps={{ danger: true }}
                            >
                                <Link to="#" style={{ color: '#ff4d4f' }}>
                                    <FeatherIcon icon="bell-off" /> Disable Alerts on this Device
                                </Link>
                            </Popconfirm>
                        </li>
                    )}
                </ul>
                <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
                    <FeatherIcon icon="log-out" /> <span style={{color: "#eca705"}}>Sign Out</span>
                </Link>
            </div>
        </UserDropDwon>
    );

    return (
        <InfoWraper>
            <Col md={8}>
                <Modal
                    type={state.modalType}
                    title="Password Form"
                    visible={state.visible}
                    onCancel={() => handleCancel()}
                    footer={[
                        <Button
                            form="passForm"
                            key="submit"
                            htmlType="submit"
                            type="primary"
                            disabled={isLoading}
                            size="medium">
                            {isLoading ? 'Loading...' : 'Submit'}
                        </Button>
                    ]}
                >
                    <Form
                        name="Change Password"
                        form={form}
                        id="passForm"
                        validateMessages={validateMessages}
                        onFinish={handleSubmit}>
                        <Form.Item name="currentPassword" rules={[{ required: true }]} label="Current Password">
                            <Input.Password placeholder="Current Password" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: 'Please enter your new password!' },
                                { min: 6, message: 'Password must be at least 6 characters long!' }
                            ]}
                            label="New Password">
                            <Input.Password placeholder="New Password" />
                        </Form.Item>
                    </Form>
                </Modal>
            </Col>

            <div className="nav-author">
                {/* MAILBOX LINK WITH RESPONSIVE ACCENT ADJUSTMENTS */}
                {Scope.checkScopes(['domain_emails_teachers_index']) && (
                    <Link to={`${path}/domain-emails/teachers`} style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Badge
                            offset={[4, -2]}
                            count={
                                teacherUnseenEmails?.data > 0 ? (
                                    <div
                                        style={{
                                            backgroundColor: '#ff4d4f',
                                            color: 'white',
                                            padding: '0px 4px',
                                            borderRadius: '10px',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            minWidth: '16px',
                                            height: '16px',
                                            lineHeight: '16px',
                                            textAlign: 'center',
                                            boxShadow: '0 0 0 1px #fff'
                                        }}
                                    >
                                        {teacherUnseenEmails.data}
                                    </div>
                                ) : null
                            }
                        >
                            <FeatherIcon
                                icon="mail"
                                size={windowWidth < 576 ? 18 : 20}
                                style={{ color: teacherUnseenEmails?.data > 0 ? '#1677ff' : '#595959' }}
                            />
                        </Badge>
                    </Link>
                )}

                {/* NOTIFICATIONS PUSH TOGGLE ACCENT */}
                <Popconfirm
                    title="Enable Mobile Notifications?"
                    description="Receive instant alerts for official emails on your phone."
                    onConfirm={handleSyncNotifications}
                    okText="Yes, Enable"
                    cancelText="No"
                    placement="bottomRight"
                    disabled={isThisDeviceEnabled}
                >
                    <Button
                        size="small"
                        style={{
                            color: isThisDeviceEnabled ? '#20c997' : '#ff4d4f',
                            borderColor: isThisDeviceEnabled ? '#20c997' : '#ff4d4f',
                            padding: windowWidth < 576 ? '2px 6px' : '4px 10px'
                        }}
                    >
                        <FeatherIcon icon={isThisDeviceEnabled ? "bell" : "bell-off"} size={14} />
                        {isThisDeviceEnabled && (
                            <FeatherIcon
                                icon="check"
                                size={12}
                                style={{ marginLeft: '2px', strokeWidth: '3px' }}
                            />
                        )}
                    </Button>
                </Popconfirm>

                {/* RESPONSIVE QUICK SEARCH CONTAINER */}
                {Scope.checkScopes(['quick_search_index']) && (
                    <Link to={`/admin/quick-search`}>
                        <Button
                            size="small"
                            style={{ padding: windowWidth < 576 ? "2px 6px" : "1px 8px" }}
                            type="primary"
                        >
                            <FeatherIcon icon="search" style={{ width: "14px" }} size={12} />
                            {windowWidth >= 576 && (
                                <small style={{ marginLeft: '4px' }}>Quick Search</small>
                            )}
                        </Button>
                    </Link>
                )}

                {/* USER PROFILE DROPDOWN */}
                <Popover placement="bottomRight" content={userContent} action="click">
                    <Link to="#" className="head-example" style={{ display: 'inline-flex' }}>
                        <Avatar src={userPhotoUrl} size={windowWidth < 576 ? 32 : 40} />
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
};

export default AuthInfo;